export const WEIGHT_LABELS: { [key: string]: string } = {
  'eighth ounce': '3.5g',
  gram: '1g',
  'half gram': '0.5g',
  'half ounce': '14g',
  ounce: '28g',
  'quarter ounce': '7g',
  'two gram': '2g',
};

export const WEIGHT_TO_GRAMS: { [key: string]: number } = {
  eighth_ounce: 3.5,
  'eighth ounce': 3.5,
  gram: 1.0,
  half_gram: 0.5,
  half_ounce: 14,
  'half gram': 0.5,
  'half ounce': 14,
  ounce: 28,
  quarter_ounce: 7,
  'quarter ounce': 7,
  two_gram: 2.0,
  'two gram': 2.0,
};

export const ALL_FACETS = [
  'activities',
  'aggregate_rating',
  'applicable_brand_special_ids',
  'applicable_bulk_special_ids',
  'applicable_bundle_special_ids.discount',
  'applicable_bundle_special_ids.qualify',
  'applicable_cart_total_special_ids',
  'applicable_special_ids',
  'available_weights',
  'brand',
  'bucket_price',
  'category',
  'compound_names',
  'feelings',
  'has_brand_discount',
  'kind_brand_subtype',
  'kind_root_subtype',
  'kind',
  'percent_cbd',
  'percent_thc',
  'root_types',
];
